/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useContext } from "react";
import PropTypes from "prop-types";
import utils from "utils";
import { AuthorizationContext } from "contexts/AuthorizationContext";

const BackgroundHeader = ({ children }) => {
  const context = useContext(AuthorizationContext);
  // A super admin's header takes a third line for the filtered organization,
  // under the badge (from md up, as the name): the cards start lower.
  const hasThirdLine =
    !!context?.isOrgFilterEnabled && !!context?.filteredOrganization && utils.isUserAdmin();
  return (
    <>
      <div className={`bg-gradient-info pb-9 pt-5 ${hasThirdLine ? "pt-md-8" : "pt-md-7"}`}>
        {children}
      </div>
    </>
  );
};

BackgroundHeader.propTypes = {
  children: PropTypes.node,
};

export default BackgroundHeader;
